
function ProjectTable({ projects, type, minSize, district, minYear }) {

  if (!Array.isArray(projects)) {
    return <p>No projects to show (not array)</p>;
  }

  const minArea = parseFloat(minSize);
  const minHandover = parseInt(minYear);

  const filtered = projects.filter(project =>
    (!type || project.type === type) &&
    (!minArea || project.area_m2 >= minArea) &&
    (!district || project.district === district) &&
    (!minHandover || project.handover_year >= minHandover)
  );

  if (filtered.length === 0) {
    console.log("projects is an empty array");
    return <p>No projects match your filter.</p>
  }

  return (
    <div
      style={{
        marginLeft: '250px', // Adjust this value to match the width of the filter panel
        padding: '16px', // Optional: Add padding for spacing
      }}
    >
      <table>
        <thead>
          <tr>
            <th>Project</th>
            <th>Price (M VND)</th>
            <th>District</th>
            <th>Area (m²)</th>
            <th>Type</th>
            <th>Handover Year</th>
            <th>Score</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((project, index) => (
            <tr key={index}>
              <td>{project.name}</td>
              <td>{project.price_million_vnd}</td>
              <td>{project.district}</td>
              <td>{project.area_m2}</td>
              <td>{project.type}</td>
              <td>{project.handover_year}</td>
              <td>{project.score}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ProjectTable;